import { purchaseLineMoney,purchaseTotal } from '../purchase-planning/money.ts';
export function supplierQuoteTotals(rows:{currency:string|null;unit_cost:number|null;quantity:number}[]){
 const minor=new Map<string,bigint>();let missing=0;
 for(const r of rows){
  if(!r.currency||r.unit_cost===null){missing++;continue;}
  try{const line=purchaseLineMoney(r.quantity,String(r.unit_cost),'0','0',r.currency);const next=(minor.get(r.currency)||0n)+line.netMinor;purchaseTotal(next,r.currency);minor.set(r.currency,next);}catch{missing++;}
 }
 return {values:Array.from(minor,([currency,total])=>({currency,amount:purchaseTotal(total,currency)})),missing};
}
